import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { OverlayBanner } from 'cstar-react-primitives/lib/redux-form/layout/OverlayBanner';

import { getGdprEnabled } from '../brand/brandSelectors';
import { getPrivacyPolicyPath } from '../routing/flow';

import { getCookieConsentGiven } from './consentSelectors';
import { setCookieConsentGiven } from './consentModule';
import consentMessages from './consentMessages';


export const CookieConsentBanner = ({
    intl,
    gdprEnabled,
    consentGiven,
    clickHandler
}) => {
    if (!gdprEnabled || consentGiven) {
        return null;
    }
    const bannerProps = {
        message: intl.formatMessage(consentMessages.cookieConsentMessage, { url: getPrivacyPolicyPath() }),
        buttonText: intl.formatMessage(consentMessages.cookieConsentButtonText),
        cashbotName: 'cookie-consent-agree-button',
        onClick: clickHandler,
        openLinksInNewTab: true
    };
    return (
        <div>
            <OverlayBanner {...bannerProps} />
        </div>
    );
};

CookieConsentBanner.defaultProps = {
    gdprEnabled: false,
    consentGiven: false
};

CookieConsentBanner.propTypes = {
    intl: intlShape.isRequired,
    gdprEnabled: PropTypes.bool,
    consentGiven: PropTypes.bool,
    clickHandler: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    gdprEnabled: getGdprEnabled(state),
    consentGiven: getCookieConsentGiven(state)
});

const mapDispatchToProps = {
    clickHandler: () => setCookieConsentGiven(true)
};

export const ConnectedCookieConsentBanner = React.memo(
    injectIntl(connect(mapStateToProps, mapDispatchToProps)(CookieConsentBanner))
);
